import { render, staticRenderFns } from "./RecordBox.vue?vue&type=template&id=18e21a46&scoped=true"
import script from "./RecordBox.vue?vue&type=script&lang=js"
export * from "./RecordBox.vue?vue&type=script&lang=js"
import style0 from "./RecordBox.vue?vue&type=style&index=0&id=18e21a46&prod&lang=scss&scoped=true"
import style1 from "./RecordBox.vue?vue&type=style&index=1&id=18e21a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e21a46",
  null
  
)

export default component.exports